export default __webpack_public_path__ + "static/media/ReportsSnapshot.88d0786f.jpg";